import React from 'react';
import PropTypes from 'prop-types';
import { StyledNavigation } from './styled';

const Navigation = ({ children, customStyle }) => {
    return (
        <StyledNavigation
            customStyle={customStyle}
        >
            {children}
        </StyledNavigation>
    );
};

Navigation.propTypes = {
    children: PropTypes.node,
    customStyle: PropTypes.array
};

Navigation.defaultProps = {
};

export default React.memo(Navigation);